var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { FirebaseAuthContext } from 'libs.firebase_react';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { ApiClientService, useApiClient } from 'libs.react';
import { useAddLocalizationImportNotificationHook, } from './useAddLocalizationImportNotification.hook';
export function useLocalizationImport() {
    const { post } = useApiClient(ApiClientService.WEB);
    const { addNotification } = useToastNotification();
    const translate = useLocalizeMessage();
    const { firebaseToken } = useContext(FirebaseAuthContext);
    const { handleAddNotification } = useAddLocalizationImportNotificationHook();
    const { mutate: importLocalization, isPending } = useMutation({
        mutationKey: ['translation', 'import'],
        mutationFn: ({ formData, requiredIds, supportedLocales, }) => __awaiter(this, void 0, void 0, function* () {
            const idPairs = (requiredIds === null || requiredIds === void 0 ? void 0 : requiredIds.map((id) => `ids[]=${id}`)) || [];
            const localePairs = (supportedLocales === null || supportedLocales === void 0 ? void 0 : supportedLocales.map((locale) => `locales[]=${locale}`)) || [];
            const q = [...idPairs, ...localePairs].join('&');
            if (!firebaseToken) {
                addNotification({
                    title: translate('Network error: please try again in a moment'),
                    type: 'error',
                });
                return;
            }
            return yield post(`/api/translation/import?${q}`, formData, {
                // Pass firebase token, don't pass medable token
                withCredentials: false,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${firebaseToken}`,
                },
            });
        }),
        onSettled: (data, error) => {
            var _a, _b, _c;
            const success = ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.success) || ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.success);
            handleAddNotification(success, !!error);
        },
        retry: 1,
    });
    return {
        importLocalization,
        isPending,
    };
}
//# sourceMappingURL=localization_import.hook.js.map